import styled from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyledCard = styled.div<Props>`
  border-radius: 4px;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  box-shadow: 0 4px 4px 0 rgba(0, 9, 90, 0.22);
  display: flex;
  width: 100%;
  flex-direction: column;
  min-width: 240px;
  height: auto;
`;
